import { PatientListFiltersData } from '@lmt/unicorn-shared/app/components/patients/list/common/types';
import { FieldsWithType } from '@lmt/unicorn-shared/app/helpers/typeUtils';
import FilterIcon from '@lmt/unicorn-shared/src/app/icons/filter.svg?react';
import FilterBubbledIcon from '@lmt/unicorn-shared/src/app/icons/filter-bubble.svg?react';
import clsx from 'clsx';
import React, { FC } from 'react';
import styles from './FiltersButton.module.scss';

export type TogglableOptions = FieldsWithType<
  PatientListFiltersData,
  boolean | undefined
>;

interface Props {
  isFiltersBlockShown: boolean;
  isFilterApplied: boolean;
  onClick: () => void;
  className?: string;
}

export const FiltersButton: FC<Props> = (props) => {
  const { isFiltersBlockShown, isFilterApplied, onClick, className } = props;

  const classNames = clsx([
    className,
    styles.iconButton,
    isFiltersBlockShown && styles.greyed,
  ]);

  if (isFilterApplied && !isFiltersBlockShown) {
    return (
      <FilterBubbledIcon
        className={classNames}
        onClick={onClick}
        data-test-id="patient-list-filter-button"
      />
    );
  }
  return (
    <FilterIcon
      className={classNames}
      onClick={onClick}
      data-test-id="patient-list-filter-button"
    />
  );
};
